export default __webpack_public_path__ + "static/media/PromoBannerSprite.71d84590.png";